import { buildMonitorApiUrl } from '@api/api';

const mapUserData = (user) => ({
  ...user,
  authorized_for_upgrade_agents: user.authorized_for_upgrade_agents === 1,
});

export const fetchUserInfo = async () => {
  try {
    const response = await fetch(buildMonitorApiUrl('/auth/userinfo'));
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const { data } = await response.json();
    return {
      status: 'success',
      data: data.map(mapUserData),
    };
  } catch (error) {
    return {
      status: 'error',
      message: error.message,
    };
  }
};
